<template>
  <div class="header">
    <div class="top topth">
      <div class="logoContainer">
        <div class="logoth">
          <img src="/assets/pgsoft.png" alt="Logo" />
        </div>
        <div class="cross">
          <div></div>
          <div></div>
        </div>
        <div class="askmebet">
          <img src="/assets/logo-askmebet.png" alt="askmebet" />
        </div>
      </div>
      <div class="line lineth"></div>
      <div class="license licenseth">
        <div>
          <div class="gtext">{{ $t("license") }}</div>
          <div class="logos">
            <!-- <div class="gambling">
              <img src="/assets/gambling%20commission.png" />
            </div> -->
            <div class="mga">
              <img src="/assets/mga.png" />
            </div>
          </div>
        </div>
        <div>
          <div class="gtext">{{ $t("certificate") }}</div>
          <div class="logos">
            <div class="ga">
              <img src="/assets/ga.png" />
            </div>
            <div class="bmm">
              <img src="/assets/bmm.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="certified" v-html="$t('certified')"></div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    lang: String,
  },
};
// definePageMeta({
//   title: "Welcome Page",
// });
</script>

<style scoped></style>
